/* Priyanka Musical House — accessible product tabs (<pmh-product-tabs>) */
if (!customElements.get('pmh-product-tabs')) {
  customElements.define(
    'pmh-product-tabs',
    class PmhProductTabs extends HTMLElement {
      connectedCallback() {
        this.tablist = this.querySelector('[role="tablist"]');
        this.tabs = Array.from(this.querySelectorAll('[role="tab"]'));
        if (!this.tablist || !this.tabs.length) return;

        this.tabs.forEach((tab, i) => {
          tab.addEventListener('click', () => this.select(i, false));
        });

        this.tablist.addEventListener('keydown', (event) => {
          const current = this.tabs.indexOf(document.activeElement);
          if (current === -1) return;
          let next = null;
          switch (event.key) {
            case 'ArrowRight':
            case 'ArrowDown':
              next = (current + 1) % this.tabs.length;
              break;
            case 'ArrowLeft':
            case 'ArrowUp':
              next = (current - 1 + this.tabs.length) % this.tabs.length;
              break;
            case 'Home':
              next = 0;
              break;
            case 'End':
              next = this.tabs.length - 1;
              break;
            default:
              return;
          }
          event.preventDefault();
          this.select(next, true);
        });

        this.onBlockSelect = (event) => {
          const i = this.tabs.findIndex((tab) => tab.dataset.blockId === event.detail.blockId);
          if (i > -1) this.select(i, false);
        };
        document.addEventListener('shopify:block:select', this.onBlockSelect);
      }

      disconnectedCallback() {
        if (this.onBlockSelect) document.removeEventListener('shopify:block:select', this.onBlockSelect);
      }

      select(index, moveFocus) {
        this.tabs.forEach((tab, i) => {
          const active = i === index;
          tab.setAttribute('aria-selected', active ? 'true' : 'false');
          tab.setAttribute('tabindex', active ? '0' : '-1');
          const panel = document.getElementById(tab.getAttribute('aria-controls'));
          if (!panel) return;
          if (active) {
            panel.removeAttribute('hidden');
            const grid = panel.querySelector('.pmh-tabs__grid');
            if (grid) grid.scrollLeft = 0;
          } else {
            panel.setAttribute('hidden', '');
          }
        });

        const activeTab = this.tabs[index];
        if (!activeTab) return;
        if (moveFocus) activeTab.focus({ preventScroll: true });
        this.revealTab(activeTab);
      }

      revealTab(tab) {
        const list = this.tablist;
        if (list.scrollWidth <= list.clientWidth) return;
        const left = tab.getBoundingClientRect().left - list.getBoundingClientRect().left + list.scrollLeft;
        const right = left + tab.offsetWidth;
        if (left < list.scrollLeft) {
          list.scrollLeft = Math.max(0, left - 16);
        } else if (right > list.scrollLeft + list.clientWidth) {
          list.scrollLeft = right - list.clientWidth + 16;
        }
      }
    }
  );
}
